module.exports = __webpack_public_path__ + "static/media/5ed7380431d6be3b4dcffa39.1da0c687.png";